module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado18.561e1b97.svg";